export default __webpack_public_path__ + "static/media/ubereem.6956fb9a.jpg";